module.exports = __webpack_public_path__ + "static/media/pod-info-alert.919232bd.svg";